/**
 * Created by slava on 20/2/18
 */

const Chooser = cc.Node.extend({
    ctor: function (table, options) {
        this._super();
        this.setAnchorPoint(0.5, 0.5);
        this.setLocalZOrder(100);
        this.table = table;

        this.options = options || {};

        this.onSelect = function () {};
        this.onBeforeSelect = function () {};

        const views = [];
        this.initViews = {};

        for (const key in table) {
            const view = table[key];
            this.initViews[key] = view;
            this.addChildForKey(view, key);
            views.push(view);
        }

        const grid = new cleverapps.GridLayout(views, {
            columns: this.options.columns || 8,
            margin: {
                x: this.options.margin,
                y: this.options.margin
            }
        });
        this.setContentSize(grid.getContentSize());
        this.addChild(grid);
        grid.setPosition(this.width / 2, this.height / 2);

        if (this.options.bg) {
            const bg = cleverapps.UI.createScale9Sprite(this.options.bg);
            bg.setContentSize(this.getContentSize());
            bg.setPosition(this.width / 2, this.height / 2);
            bg.setLocalZOrder(-1);
            this.addChild(bg);
        }

        if (this.options.removeOnAsideClick) {
            cleverapps.pointerManager.create(this, {
                onOuterTouch: function () {
                    this.removeFromParent();
                }.bind(this)
            });
        }
    },

    setSelected: function (key) {
        if (this.selected) {
            this.removeSelection(this.selected);
            if (this.subChooser) {
                this.subChooser.removeFromParent();
            }
        }

        this.selected = key;

        if (key !== undefined) {
            this.showSelected(key);
        }
    },

    showSelected: function (key) {
        const view = this.table[key];

        if (this.options.scaleSelected) {
            view.setScale(this.options.scaleSelected);
        } else {
            view.selection = new cc.Sprite(bundles.editor ? bundles.editor.frames.editor_select : bundles.avatar.frames.avatar_frame);

            view.selection.setScale(Math.max(view.height, view.width) / view.selection.height);
            view.selection.setPosition(view.width / 2, view.height / 2);
            view.selection.setLocalZOrder(4);
            view.addChild(view.selection);
        }
    },

    removeSelection: function (key) {
        const view = this.table[key];

        if (this.options.scaleSelected) {
            view.setScale(1);
        } else {
            const selection = view.selection;
            selection.removeFromParent();
            delete view.selection;
        }
    },

    addChildForKey: function (view, key) {
        if (!this.options.noControl) {
            cleverapps.pointerManager.create(view, {
                swallowEvents: true,
                onClick: function () {
                    if (!this.visible) {
                        return;
                    }

                    this.runAction(new cc.Sequence(new cc.DelayTime(0), new cc.CallFunc(() => {
                        this.onBeforeSelect.call(this, key, view);
                        if (!this.disabled) {
                            if (this.selected && key === this.selected) {
                                if (this.options.noUnselect) {
                                    return;
                                }
                                this.removeSelection(this.selected);
                                this.selected = undefined;
                                if (this.subChooser) {
                                    this.subChooser.removeFromParent();
                                }
                                return;
                            }
                            this.setSelected(key);
                            this.onSelect.call(this, key, view);
                        }
                    })));
                }.bind(this)
            });
        }
    }
});